/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

export interface LightIconProps {
  color?: string;
  size?: IconSize;
}
/*
 * Defines the Design Language System (DLS) Light Icon component.
 */
export const LightIcon = ({size = IconSize.small, color}: LightIconProps) => {
  const {iconSize} = useIconDLS({size});
  const legacyColor = color || dlsColor('aaBlue');
  return (
    <ThemeIconProvider name='LightIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 28 27" fill={dlsColor('white')} xmlns="http://www.w3.org/2000/svg">
        <path d="M13.6829 19.046C16.7918 19.046 19.3121 16.5624 19.3121 13.4987C19.3121 10.435 16.7918 7.95142 13.6829 7.95142C10.574 7.95142 8.05371 10.435 8.05371 13.4987C8.05371 16.5624 10.574 19.046 13.6829 19.046Z" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M13.6884 4.82667L13.6802 1" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M13.6884 26L13.6802 22.1733" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M4.88312 13.4958L1 13.5041" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M26.369 13.4958L22.4858 13.5041" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M7.74097 19.8994L5.12891 22.7267" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M22.24 4.27319L19.6279 7.10052" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M7.38638 7.43932L4.60107 4.77441" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M22.7682 22.2257L19.9829 19.5608" stroke={legacyColor} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      </svg>
    )} />

  );
};
